<template>
  <div>
    <div v-if="showMask" class="login-mask fixed" @click="login"></div>
  </div>
</template>

<script>
export default {
  name: 'MaskDialog',
  props: {
    url: String,
    showMask: Boolean
  },
  data() {
    return {}
  },
  methods: {
    login() {
      this.$router.push({
        name: 'login'
      })
    }
  }
}
</script>

<style lang="less" scoped>
.login-mask {
  width: 100%;
  height: 100vh;
  z-index: 99;
  left: 0;
  top: 0;
}
</style>
